import React, { useEffect, useState } from 'react';
import { Form, Modal } from 'react-bootstrap';
import '../../Assets/css/myaccount.css'
import TextField from '@mui/material/TextField';
import { Col, Container, Row } from 'react-bootstrap';
import Button from '@mui/material/Button';
import ReCAPTCHA from "react-google-recaptcha";
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import moment from 'moment';
import axios from 'axios';
import { base_url, postHeader } from '../../Helpers/request';
import swal from 'sweetalert';
import { Helmet } from 'react-helmet';
import { InputLabel, MenuItem, FormControl, Select } from '@mui/material';
import { Breadcrumbs, Typography } from '@material-ui/core';
import { NavLink } from 'react-router-dom';
import Loader from '../../Components/Loader';
import { useSelector } from 'react-redux';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

const isWeekend = (date) => {
    const day = date.day();

    return day === 0;
};


const MakeAnAppointment = () => {
    const metaDetails = useSelector(state => state.persistedReducer.meta.meta)
    // const [date, setDate] = useState(
    //     moment(new Date()).add(1, 'days').format("YYYY-MM-DD")
    // );
    const [dob, setDob] = useState(moment(new Date()).add(1, 'days').format("YYYY-MM-DD"));
    const [capchaloading, setCapchaLoading] = useState(true)
    const [ifSaturday, setIfSaturday] = useState(0);
    const [time, setTime] = useState('10:30 AM');
    const [firstname, setFirstname] = useState('');
    const [lastname, setLastname] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [comment, setComment] = useState('');
    const [loader, setLoader] = useState(false)

    const onChange = (value) => {
        if (value) {
            setCapchaLoading(false)
        }
    }

    const onExpire = () => {
        setCapchaLoading(true)
    }



    const handleChangeDatePicker = (newValue) => {
        setIfSaturday(newValue.day())
        setDob(newValue)
    }


    const submitForm = (e) => {
        e.preventDefault();
        setLoader(true)
        var data = {
            first_name: firstname,
            last_name: lastname,
            email: email,
            phone: phone,
            date: dob,
            time: time,
            comment: comment,
        }
        axios.post(base_url + '/common/makeappointment', data, {
            headers: postHeader
        })
            .then(response => {
                if (response.data.status == 1) {
                    setLoader(false)
                    setFirstname("");
                    setLastname("");
                    setEmail("");
                    setComment("");
                    setPhone("");
                    setTime("");
                    setDob(moment(new Date()).add(1, 'days').format("YYYY-MM-DD"));
                    return swal(response.data.message, "", "success");
                } else {
                    setLoader(false)
                    return swal(response.data.message, "", "error");
                }
            })
            .catch((error) => {
                setLoader(false)
                console.log(error);
            });
    }
    useEffect(() => {
        const script = document.createElement('script');
        script.src = 'https://assets.calendly.com/assets/external/widget.js';
        script.async = true;
        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, []);
    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>{metaDetails?.title}</title>
                <meta name="description" content={metaDetails?.description}></meta>
                <meta name="keywords" content={metaDetails?.keywords}></meta>
            </Helmet>
            <div className='rcs_ringsetting_section mt-3'>
                <Container>
                    <Row>
                        <Col className="rcs_breadcrumb mb-2">
                            <Breadcrumbs aria-label="breadcrumb">
                                <NavLink underline="hover" color="inherit" to="/">
                                    Home
                                </NavLink>
                                <Typography color="text.primary">
                                    Make An Appointment
                                </Typography>
                            </Breadcrumbs>
                        </Col>
                    </Row>
                </Container>
            </div>
            <Col sm={12} md={12} lg={12}>
                    <div className='dfl_calendly_margin_top'>
                        <div className="calendly-inline-widget" data-url={`https://calendly.com/d/357-b87-qjy`} style={{ minWidth: '320px', height: '700px' }}></div>
                    </div>
            </Col>
            {/* <div>
                <Container>

                </Container>
            </div> */}


            <Modal show={loader}>
                <Loader />
            </Modal>
        </>
    )
}

export default MakeAnAppointment;